import React, { Component } from 'react';

class ProfileIcon extends Component {
  render() {
    return (
      <div>
        <svg
          width="24"
          height="26"
          viewBox="0 0 16 20"
          fill={this.props.selected ? "#fff" : "none"}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.98493 13.3462C4.11731 13.3462 0.814453 13.931 0.814453 16.2729C0.814453 18.6148 4.09636 19.2205 7.98493 19.2205C11.8525 19.2205 15.1545 18.6348 15.1545 16.2938C15.1545 13.9529 11.8735 13.3462 7.98493 13.3462Z"
            stroke="#fff"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.98489 10.0059C10.523 10.0059 12.5801 7.94779 12.5801 5.40969C12.5801 2.8716 10.523 0.814453 7.98489 0.814453C5.44679 0.814453 3.3887 2.8716 3.3887 5.40969C3.38013 7.93922 5.42394 9.99731 7.95251 10.0059H7.98489Z"
            stroke="#fff"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="28"
          viewBox="0 0 18 22"
        >
          <path
            style={{ fill: "none" }}
            d="M6.433 14.905c1.583-.128 3.175-.128 4.758 0 .863.05 1.722.158 2.57.322 1.837.372 3.036.98 3.55 1.958.385.764.385 1.672 0 2.437-.514.979-1.666 1.625-3.569 1.958-.848.17-1.707.281-2.57.332C10.374 22 9.574 22 8.766 22H7.308c-.293-.038-.588-.058-.884-.058-.863-.045-1.722-.153-2.57-.324-1.837-.352-3.036-.979-3.55-1.958-.198-.38-.302-.802-.304-1.23-.004-.433.097-.86.295-1.244.505-.979 1.704-1.614 3.56-1.958.85-.167 1.712-.275 2.578-.322v-.001zM8.803 0c3.19 0 5.775 2.66 5.775 5.94 0 3.281-2.585 5.94-5.775 5.94-3.19 0-5.778-2.658-5.778-5.94C3.025 2.66 5.611 0 8.802 0h.001z"
          />
        </svg> */}
      </div>
    );
  }
}

export default ProfileIcon;
